import t from "./highrise1766.mjs";
import r from "./highrise1767.mjs";
var a = r(t);
export {
  a as default
};
